<template>  
  <div id="app">
    <div class="switch">
      <el-select 
      v-model="activateColor" 
      placeholder="请选择"
      size="small">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          <!-- 左侧小色块 + 右侧文字 -->
          <span class="color-dot" :style="{ background: item.color }"></span>
          {{ item.label }}
        </el-option>
      </el-select>
      <div>
        <el-button
        size="small"
        @click="toggleValueDisplay"
        >
          {{ buttonText }}
        </el-button>
        <el-button
        size="small"
        type="primary"
        @click="downloadCSV"
        >
          Download heatmap data
        </el-button>
      </div>
    </div>
    
    <div id="Heatmap" class="Heatmap"></div>
  </div>
</template>
    
    <script>
import * as echarts from "echarts";
export default {
  props: ["initialNames", "initialGenes", "initialData", "initialSpecies"],
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Heatmap",
  data() {
    return {
      isValueHidden: false,
      activateColor: "blue",
      colormap: {
        // 绿 蓝 橙 紫
        "green": ["#e6f5e0", "#afdd8b", "#7dc69f", "#009d73" , "#2a6b2f"],
        "blue": ["#e6f7ff", "#91d5ff", "#1890ff", "#1890ff" , "#002c8c"],
        "orange": ["#fff2e8", "#ffa940", "#fa8c16", "#d46b08" , "#874d00"],
        "purple": ["#f2e7fa", "#b37feb", "#722ed1", "#531dab" , "#22075e"],


      },
      options: [
        { value: "green", label: "green", color: "green" },
        { value: "blue", label: "blue", color: "blue" },
        { value: "orange", label: "orange", color: "orange" },
        { value: "purple", label: "purple", color: "purple" }, 
      ],
      species: [
        "AF204057.1",
        "AP011077.1",
        "OX941098.1",
        "OQ947725.1-OQ947727.1",
        "AF204057.1",
        "AP011077.1",
        "OX941098.1",
        "OQ947725.1-OQ947727.1",
      ],
      Name: [],
      genes: [
        "atp1",
        "atp4",
        "atp6",
        "atp8",
        "atp9",
        "ccmB",
        "ccmC",
        "ccmFc",
        "ccmFn",
        "cob",
        "cox1",
        "cox2",
        "cox3",
        "matR",
        "mttB",
        "nad1",
        "nad2",
        "nad3",
        "nad4",
        "nad4L",
        "nad5",
        "nad6",
        "nad7",
        "nad9",
      ],
      data: [],
    };
  },
  computed: {
    // ③ 计算属性：只要 activeKey 变，colorList 立即变
    colorList() {
      return this.colormap[this.activateColor]
    },
    buttonText() {
      return this.isValueHidden ? 'Show value' : 'Hide value';
    }
  },
  watch: {
    // ④ 监听：colorList 一变就重绘
    colorList(newColors) {
      this.updateColors(newColors)
    },
    // 显示/隐藏变化 → 只改 label
    isValueHidden(val) {
      this.char?.setOption({
        series: [{ label: { show: !val } }]
      })
    },
  },
  methods: {
    toggleValueDisplay() {
      this.isValueHidden = !this.isValueHidden;
      // 这里可以添加其他逻辑，比如实际隐藏/显示值的操作
    },
    downloadCSV() {
      let csvContent = "Species," + this.initialNames.join(",") + "\n";
      
      let matrix = Array.from({ length: this.initialGenes.length }, () => Array(this.initialNames.length).fill(0));
      
      this.initialData.forEach(item => {
        let g = item[0];
        let s = item[1];
        let val = item[2];
        if (matrix[g]) {
          matrix[g][s] = val;
        }
      });
      
      for (let g = 0; g < this.initialGenes.length; g++) {
        csvContent += this.initialGenes[g] + "," + matrix[g].join(",") + "\n";
      }
      
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "heatmap.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    // 1. 在 methods 里加上（推荐封装，后续可扩展）
    updateColors(colors) {
      if (!this.char) return
      // 只更新 visualMap 的 color 字段
      this.char.setOption({
        visualMap: {
          inRange: { color: colors }
        }
      })
    },
    async initChart() {
      this.char = echarts.init(document.getElementById("Heatmap"), null, {
        renderer: "svg",
      });
      this.char.setOption({
        textStyle: {
          fontFamily: "Arial", // 设置字体为 Arial
        },
        tooltip: {
          position: "top",
        },
        toolbox: {
          show: 1,
          x: 1011,
          y: 40,
          feature: {
            saveAsImage: {
              show: true,
              title: "download",
              type: "png",
              name: "Heatmap",
            },
          },
        },
        grid: {
          height: "70%",
          top: "1%",
        },
        xAxis: {
          type: "category",
          data: this.initialNames,
          splitArea: {
            show: true,
          },
          axisLabel: {
            inside: false,
            textStyle: {
              fontSize: "10",
              itemSize: "",
              fontStyle: "italic",
            },
            interval: 0,
            rotate: "55",
          },
        },
        yAxis: {
          type: "category",
          data: this.initialGenes,
          splitArea: {
            show: true,
          },
          axisLabel: {
            inside: false,
            interval: 0, // 关键：设置为0表示显示所有标签
            textStyle: {
              fontSize: "10",
              itemSize: "",
              fontStyle: "italic",
            },
          },
        },

        visualMap: {
          min: 0,
          max: 5,
          calculable: true,
          orient: "vertical",
          left: "90%",
          bottom: "70%",
          inRange: {
            // color: ["#e6f5e0", "#afdd8b", "#7dc69f", "#009d73" , "#2a6b2f"], // 设置热力图的颜色范围
            color: this.colorList   // ← 响应式引用,设置热力图的颜色范围
          },
        },
      });

      this.char.setOption({
        series: [
          {
            name: "Punch Card",
            type: "heatmap",
            data: this.initialData,
            label: {
              show: true,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });

      this.char.setOption({
        series: [
          {
            name: "Number of genes",
            type: "heatmap",
            data: this.initialData.map(function (item) {
              return [item[1], item[0], item[2]];
            }),
            label: {
              show: !this.isValueHidden,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
  },

  async mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
};
</script>
<style scoped>
.Heatmap {
  /* width: 870px;
  height: 560px; */
  width: 1100px;
  height: 800px;
  margin-top: 20px;
  margin: auto;
  background-color: white;
  border-radius: 10px;
}
.switch {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f7f7;
  border-radius: 4px;
  box-shadow: 0 2px px 0 rgba(0, 0, 0, 0.1);
}
.el-select {
  margin: 10px;
  border-radius: 4px;

}
.color-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 8px;
  vertical-align: middle;
}
.el-button {
  margin: 10px;
  border-radius: 4px;
} 
</style>